import React from 'react'
import PropTypes from 'prop-types'
import PresentationTable from '../PerformancePresentationTable'
import { useCollapsibleColumns } from '../../../../hooks/useCollapsibleColumns'
import { usePivotData } from './usePivotData'
import { usePivotColumns } from './usePivotColumns'

const defaultColumns = [
  { header: 'Name', accessor: 'levelName', align: 'left', width: 500 },
  { header: '*', format: 'marketValue', align: 'right' },
  { header: 'Allocation', format: 'allocation', align: 'right', accessor: 'allocation' },
  { header: 'Total', accessor: 'value', align: 'right', format: 'marketValue' }
]

const defaultDefaultSort = [{ id: 'levelName', desc: false }]

const PerformancePivotTable = ({
  defaultFilter,
  groupings,
  pivotAccessor,
  pivotGroup,
  groupIdentifierAccessor,
  allocationAccessor,
  initialExpandDepth,
  rowFilters,
  columnConfig,
  defaultSort,
  ignoreGroupings,
  enableColumnGrouping,
  defaultColumnsExpanded
}) => {
  const { data, pivotColumns, isLoading, onLevelExpand } = usePivotData({
    defaultFilter,
    groupings,
    pivotAccessor,
    pivotGroup,
    groupIdentifierAccessor,
    allocationAccessor,
    initialExpandDepth,
    rowFilters,
    ignoreGroupings
  })
  const effectiveColumns = usePivotColumns(pivotColumns, columnConfig)

  // Use collapsible columns hook
  const {
    visibleColumns,
    collapsedGroups,
    toggleGroup
  } = useCollapsibleColumns(effectiveColumns, defaultColumnsExpanded, enableColumnGrouping)

  return (
    <PresentationTable.Wrapper>
      <PresentationTable
        styleVariant='legacy'
        data={data || []}
        loading={isLoading}
        columns={enableColumnGrouping ? visibleColumns : effectiveColumns}
        defaultSort={defaultSort}
        expandable
        onRowClick={onLevelExpand}
        collapsedGroups={collapsedGroups}
        onToggleColumnGroup={toggleGroup}
      />
    </PresentationTable.Wrapper>
  )
}

PerformancePivotTable.propTypes = {
  defaultFilter: PropTypes.object,
  groupings: PropTypes.arrayOf(PropTypes.string).isRequired,
  pivotAccessor: PropTypes.string,
  pivotGroup: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  groupIdentifierAccessor: PropTypes.string,
  allocationAccessor: PropTypes.string,
  initialExpandDepth: PropTypes.number,
  rowFilters: PropTypes.arrayOf(PropTypes.shape({
    accessor: PropTypes.string,
    op: PropTypes.oneOf(['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'exists', 'notExists']),
    value: PropTypes.any
  })),
  columnConfig: PropTypes.object,
  defaultSort: PropTypes.array,
  ignoreGroupings: PropTypes.array,
  enableColumnGrouping: PropTypes.bool,
  defaultColumnsExpanded: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['first'])
  ])
}

PerformancePivotTable.defaultProps = {
  initialExpandDepth: 2,
  columnConfig: defaultColumns,
  defaultSort: defaultDefaultSort,
  allocationAccessor: 'value',
  ignoreGroupings: [],
  enableColumnGrouping: false,
  defaultColumnsExpanded: false
}

export default PerformancePivotTable
